import { useEffect, useState } from 'react'

import { Button, ErrorState } from '../../components/ui'
import { caravanDb } from '../../services/syncRuntime'
import { lockProtectedCache } from '../../services/revocation'

export function RecoveryLock({ onAuthenticate }: { onAuthenticate: () => void }) {
  const [recoverableCount, setRecoverableCount] = useState(0)

  useEffect(() => {
    void lockProtectedCache(caravanDb).then(setRecoverableCount)
  }, [])

  return (
    <main className="access-page access-page--locked">
      <ErrorState
        title="Cet appareil n’a plus accès"
        detail={`${String(recoverableCount)} contribution(s) restent conservées. Choisis à nouveau ton prénom pour continuer.`}
      />
      <Button onClick={onAuthenticate}>Choisir mon prénom</Button>
    </main>
  )
}
